import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "relative" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "Data", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_calendar_icon = _resolveComponent("calendar-icon")!
  const _component_VDatePicker = _resolveComponent("VDatePicker")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_VDatePicker, {
      "onUpdate:modelValue": [
        $setup.addFilter,
        _cache[0] || (_cache[0] = ($event: any) => (($setup.date) = $event))
      ],
      modelValue: $setup.date,
      locale: "pt-BR",
      "first-day-of-week": 2
    }, {
      default: _withCtx(({ togglePopover }) => [
        _createElementVNode("span", {
          onClick: togglePopover,
          class: "filter-btn"
        }, [
          _createVNode(_component_calendar_icon, {
            width: 16,
            height: 16
          }),
          _hoisted_3
        ], 8, _hoisted_2)
      ]),
      _: 1
    }, 8, ["onUpdate:modelValue", "modelValue"])
  ]))
}